<template>
    <div class="bo-video-player">
        <iframe class="embed-responsive-item" :src="video" allowfullscreen></iframe>
    </div>
</template>

<script>
export default {
    props: {
        video: {
            type: String,
            default: "",
        },
    },
};
</script>
